import {formatElapsedTime} from '@Components/ai-chat-window/components/elapsed-turn-time/elapsed-turn-time.library';
import {SECONDS_BEFORE_SHOWING_STEP_TIME} from './document-chip.types';

export const getStepHeaderText = (stepLabel: string, stepElapsedSeconds: number): string => {
  return stepElapsedSeconds >= SECONDS_BEFORE_SHOWING_STEP_TIME ? `${stepLabel} ${formatElapsedTime(stepElapsedSeconds)}` : stepLabel;
};

export const getChipAccessibleName = (filename: string, typeLabel: string, detail: string | undefined): string => {
  return detail === undefined ? `${filename} (${typeLabel})` : `${filename} (${typeLabel}). ${detail}`;
};
